import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=66d1764a&scoped=true"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=66d1764a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1764a",
  null
  
)

export default component.exports